import { local_collection_set_special_collections_by_workspace_id } from '@/state/collection/entity/local_collection_set_special_collections_by_workspace_id';
import { local_collection_upsert } from '@/state/collection/entity/local_collection_upsert';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { FN_GRID2D__init_possible_features } from '../../_methods/FN_GRID2D__init_possible_features';

export function HANDLER_CLIENT__collection_upsert(items: any) {
  assert_array_instanceof(items, DTO__collection);

  FN_GRID2D__init_possible_features(items);

  store.dispatch(local_collection_upsert(items));

  let workspace_id = store.getState().slice_workspace.workspace_current._id;

  store.dispatch(local_collection_set_special_collections_by_workspace_id(workspace_id));
}
